import { AppBar, Grid, Toolbar, Box } from '@material-ui/core';
import React from 'react';
import useStyles from '../useStyles';

type FooterProps = {
  children?: React.ReactElement | React.ReactElement[];
};
const Footer = function Footer({ children }: FooterProps): React.ReactElement {
  const classes = useStyles();
  return (
    <Box displayPrint='none'>
      <AppBar position='fixed' className={classes.bottomToolbar}>
        <Toolbar>
          <Grid container justify='center' spacing={2}>
            {children}
          </Grid>
        </Toolbar>
      </AppBar>
    </Box>
  );
};

export default Footer;
